import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@cancercentrum/rcc-bootstrap';
import { AjaxErrorAlert, Explanation, useDataActions, useIncaForm, usePromise } from '@cancercentrum/rcc-react';
import { format } from 'date-fns';
import type { ListItem } from '@cancercentrum/inca';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import usePDL from '../../../pdl/usePDL.ts';
import type { EnkatregisterdeltagareVDItem } from '../types.ts';
import { importSurveyApiV1 } from '../../../utils/enkatregistret.ts';

const map: Record<string, string> = {
    email: 'e-post',
    sms: 'SMS',
};

export const getNotificationMethodText = (srcInput: string): string => {
    return map[srcInput] || srcInput;
};

export const PatientPortal = (props: {
    svarRootTableId?: number;
    deltagare: EnkatregisterdeltagareVDItem;
    onNotified: () => void;
}) => {
    const {
        svarRootTableId,
        deltagare,
        onNotified,
    } = props;
    const pdl = usePDL();
    const dataActions = useDataActions();
    const incaForm = useIncaForm();
    const notifyPromise = usePromise<boolean>();
    const notify = async () => {
        notifyPromise.exec(async () => {
            const surevyApi = await importSurveyApiV1();

            await surevyApi.send1177Notification({
                deltagareId: deltagare.id,
                source: 'ipo',
            });

            onNotified();

            const notificationDate = format(Date.now(), 'yyyy-MM-dd HH:mm:ss');

            dataActions.updateRow(r => {
                const newRow = r.getSubTable('Patientportal').createRow();

                return r.addSubTableRow(newRow
                    .setRegvarValue('Pp_datum', notificationDate)
                    .setRegvarValue('Pp_anvandarnamn', incaForm.currentUser.user.username)
                    .setRegvarValue('Pp_position_vd', incaForm.currentUser.position.id)
                    .setRegvarValue('Pp_svar_vd', svarRootTableId)
                    .setRegvarValue('Pp_notifieringsmetod', (x: ListItem) => x.identifier === '1177'),
                );
            });

            return true;
        });
    };

    if (!pdl.patientPortal.isActive) {
        return (
            <div>Saknar aktiv inkorg</div>
        );
    }

    if (!pdl.patientPortal.activeNotificationMethods.length) {
        return (
            <div>Har stängt av notiser</div>
        );
    }

    if (!svarRootTableId) {
        return null;
    }

    return (
        <div>
            <div className="d-flex align-items-center gap-2">
                <Button onClick={notify} disabled={notifyPromise.isLoading}>
                    {notifyPromise.isLoading && <><FontAwesomeIcon icon={faSpinner} spin={true} /> Skickar meddelande till 1177</>}
                    {!notifyPromise.isLoading && <>Skicka meddelande till 1177</>}
                </Button>
                <Explanation>När du klickar här skickas ett meddelande till patienten om att logga in på 1177 och besvara enkäten.</Explanation>
            </div>

            {notifyPromise.error && <AjaxErrorAlert error={notifyPromise.error} />}
        </div>
    );
};
